export const PAGE_LIMIT = 100;

export const PARAMS_NAME = {
    hour: 'Hour',
    affid: 'Affid',
    subid: 'Subid',
    country: 'Country',
    revenue: 'Revenue',
    onwRevenue: 'ONW Revenue',
    totalRevenue: 'Total Revenue',
    conversions: 'Subscribers',
    spend: 'Spend',
    roi: 'Clicks ROI',
    onwRoi: 'ONW Roi',
    totalRoi: 'ROI',
    totalPercentRoi: 'ROI %',
    peerclickConversionPrice: "PC Conversion Price",
    peerclickConversionRate: "PC Conversion Rate",
    peerclickEcpm: "PC eCPM",
    conversionPrice: 'Subscriber Price',
    pVisits: 'PC Impressions',
    pConversions: 'PC Conversions'
};

export const NAN_PARAMS = {
    date: 1,
    affid: 1,
    subid: 1,
    country: 1
};



// WEBPACK FOOTER //
// ./src/scenes/BidderNetworkPerformanceV2/config.js